/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/require-default-props */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 * @deprecated This component is deprecated and will be removed in a future release.
 * Please use the new Quimby UI component instead:
 *
 * Import: `import { Label } from '@ui';`
 *
 * Or specific path: `import { Label } from '@ui/atoms/Label';`
 *
 * See the new component for documentation and migration notes.
 */
import React from 'react';
export default function Label(_a) {
    var { htmlFor, children, className = '' } = _a, props = __rest(_a, ["htmlFor", "children", "className"]);
    return (React.createElement("label", Object.assign({ htmlFor: htmlFor, className: `qmb-label ${className}`.trim() }, props), children));
}
